import Splide from "@splidejs/splide";

const testimonialSlider = document.querySelector('.ibb-testimonials-v2-inner .splide');
if (testimonialSlider) {
    new Splide(testimonialSlider, {
        width: '100vw',
        type: 'loop',
        rewind: true,
        perMove: 1,
        focus: 'center',
        gap: '25px',
        fixedWidth: '62%',
        arrows: true,
        pagination: false,
        autoplay: true,
        interval: 10000,
        trimSpace: true,
        breakpoints: {
            1024: {
                trimSpace: false,
                fixedWidth: '100%',
            },
            768: {
                width: '88vw'
            }
        }
    }).mount();
}